import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext"
import { addMoneySimbols } from "@/app/utils/formatMoneyValue"
import { PartnerType } from "@/app/utils/partners.enum"

export const Summary = () => {
  const { type, fgtsData, panData, crefazData, cltData } = useSelfHiringContext()

  const cltSelectedTable =
    cltData?.tables?.[cltData?.selectedIndex ?? 0] ?? cltData?.tables?.[0]

  const data = {
    [PartnerType.CREFAZ]: {
      solicited: crefazData?.proposalData.value ? crefazData.proposalData.value / 100 : 0,
      blocked: 0,
      installments: crefazData?.proposalData?.prazo ?? 0,
    },
    [PartnerType.FGTS]: {
      solicited: fgtsData?.table?.ValorSolicitado ?? 0,
      blocked: fgtsData?.table?.ValorBloqueado ?? 0,
      installments: fgtsData?.table?.Prazo ?? 0,
    },
    [PartnerType.PAN]: {
      solicited: panData?.state?.selectedValue ?? 0,
      blocked: 0,
      installments: `${panData?.state?.selectedPrazo ?? 0}`,
    },
    [PartnerType.CLT]: {
      solicited: cltSelectedTable?.ValorLiquidoCliente ?? 0,
      blocked: cltSelectedTable?.ValorBruto ?? 0,
      installments: cltSelectedTable?.Prazo ?? 0,
    },
  }
  const items = [
    {
      label: 'Valor Solicitado',
      value: addMoneySimbols(data[type as keyof typeof data]?.solicited ?? 0),
    },
    {
      label: 'Valor Bloqueado',
      value: addMoneySimbols(data[type as keyof typeof data]?.blocked ?? 0),
    },
    {
      label: 'Parcelas',
      value: `${data[type as keyof typeof data]?.installments ?? 0}x`,

    }
  ]
  return (
    <div className="bg-white01 rounded-xl border border-gray02 px-5 py-3 h-min text-center dark:bg-gray-900 dark:border-gray-700">
      <h1 className="text-black01 text-md md:text-lg font-bold mb-4 pb-1 border-b-[2px] border-primary dark:text-white">
        Resumo da Proposta
      </h1>

      <div className="flex flex-col gap-3">
        {items.map((item) => (
          <>
            <div key={item.label} className="flex justify-between gap-4">
              <span className="text-black01 text-sm font-medium whitespace-nowrap dark:text-white">
                <span className="text-primary text-xs mr-1">▶</span>
                {item.label}:</span>
              <span className="text-black01 text-sm font-semibold dark:text-white">{item.value}</span>
            </div>
            <hr className="w-full h-[2px] bg-gray-300 dark:bg-gray-700" />
          </>
        ))}

      </div>
    </div>
  )
}